import store from '@/store'

export default [
  {
    path: '/admin/reports/incomes',
    name: 'daily-income-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/daily/income')
  },
  {
    path: '/admin/reports/income-by-sales',
    name: 'daily-income-by-sale-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/daily/income-by-sale')
  },
  {
    path: '/admin/reports/sale-items',
    name: 'daily-sale-item-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/daily/sale-item')
  },
  {
    path: '/admin/reports/daily-cash-flow-and-stocks',
    name: 'daily-cash-flow-and-stock',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/daily/cash-flow-and-stock')
  }
]
